const victimas = [
  {
    id: "1",
    victima: "NO APLICA"
  },
  {
    id: "2",
    victima: "DESPLAZADO"
  },
  {
    id: "3",
    victima: "DESVINCULADO DE GRUPOS ARMADOS"
  },
  {
    id: "4",
    victima: "DESMOVILIZADO"
  },
  {
    id: "5",
    victima: "VICTIMA DE MINAS"
  }
]

export default victimas